import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-secondary-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-shield-star-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50 whitespace-nowrap">男子汉宝藏</span>
            </Link>
            <p className="text-sm leading-relaxed text-secondary-400 mb-5">
              汇聚真正值得男人拥有的精品好物、生活方式与硬核装备推荐。从工具装备到品质生活，每一件都经过严苛筛选。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-800 hover:bg-primary-500 text-secondary-300 hover:text-background-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-800 hover:bg-primary-500 text-secondary-300 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-800 hover:bg-primary-500 text-secondary-300 hover:text-background-50 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-800 hover:bg-primary-500 text-secondary-300 hover:text-background-50 transition-colors" aria-label="小红书">
                <i className="ri-reddit-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors">关于我们</Link></li>
              <li><a href="#" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors">隐私政策</a></li>
              <li><a href="#" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors">用户协议</a></li>
              <li><a href="#" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors">免责声明</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-start gap-2 text-sm text-secondary-400">
                <i className="ri-mail-line mt-0.5 text-secondary-500"></i>
                <span>contact@manstreasure.cn</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-secondary-400">
                <i className="ri-map-pin-line mt-0.5 text-secondary-500"></i>
                <span>北京市朝阳区男子汉宝藏总部</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-secondary-400">
                <i className="ri-smartphone-line mt-0.5 text-secondary-500"></i>
                <span>关注微信公众号：男子汉宝藏</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-secondary-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-secondary-500">
              &copy; {new Date().getFullYear()} 男子汉宝藏 Man's Treasure. All rights reserved.
            </p>
            <p className="text-xs text-secondary-500">
              本站内容仅供学习交流，不构成购买建议。
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}